/* eslint-disable no-undef */
// import { configurationsData } from "@/data/server";
import Adapter from "@/services/adapter";
export const useMainStore = defineStore('main', () => {
  // STATE ------------------------------------------------------------------
  const appMode = ref('');
  const configurations = ref([]);

  /**
   * For reason why $fetch was used instead of useFetch() see:
   * https://www.reddit.com/r/Nuxt/comments/16zo29w/comment/ki4pq8p/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button
   * https://github.com/nuxt/nuxt/issues/13805#issuecomment-1397317230
   */
  async function fetchConfigurations() {
    try {
      // console.log('TOKEN FROM STORE', token);
      const data = await Adapter.getConfigurations();

      // console.log("DATA", data);
      configurations.value = data;
      // configurations.value = data.value.data;
    } catch (error) {
      console.error(error);
    }
  }
  async function deleteConfiguration(id) {
    try {
      await Adapter.deleteConfiguration(id);
    } catch (error) {
      console.error(error);
    }
  }
  return {
    appMode,
    configurations,
    fetchConfigurations,
    deleteConfiguration
  };
});